import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebea9824"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-container viewer"
}
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "update-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备版本升级", -1))
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "vstack service-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-adorn center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot-decoration" })
], -1))
const _hoisted_8 = { class: "service-name" }
const _hoisted_9 = { class: "service-ver" }
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = { class: "operations" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "modal-container updating"
}
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = { class: "update-icon" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务升级中", -1))
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "progress-bar" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress-track" }, null, -1))
const _hoisted_21 = { class: "tips" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 正在升级服务，请耐心等待... ")
const _hoisted_23 = { class: "progress-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "modal-container",
  tabindex: "0"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "gradient-header" }),
  /*#__PURE__*/_createElementVNode("div", { class: "gear" }),
  /*#__PURE__*/_createElementVNode("p", { class: "modal-title" }, " 设备版本升级 ")
], -1))
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = {
  key: "upgrade",
  class: "vstack"
}
const _hoisted_30 = { class: "vstack service-list" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-adorn center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot-decoration" })
], -1))
const _hoisted_32 = { class: "service-name" }
const _hoisted_33 = { class: "service-ver" }
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-text" }, " 暂不更新 ", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-text" }, " 立即更新 ", -1))
const _hoisted_38 = {
  key: 1,
  class: "vstack center updating",
  tabindex: "0"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " 服务升级中 ", -1))
const _hoisted_40 = { class: "content" }
const _hoisted_41 = { class: "progress-bar" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress-track" }, null, -1))
const _hoisted_43 = { class: "tips" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 正在升级服务，请耐心等待... ")
const _hoisted_45 = { class: "progress-text" }

import { onMounted, onUnmounted, reactive, ref, unref, computed } from 'vue'
import GradientButton from '@remote/components/GradientButton.vue'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { checkState } from '@remote/store/utils'
import { isLargeViewPort } from '@remote/utils/base'
import type { IVersionStore, IServiceItem } from '@remote/type/version'
import type { IUpdateModalRef } from './type.d'

interface IProps {
  from: 'Home' | 'ServicePage'
  center?: boolean
  closeable?: boolean
  backdrop?: boolean
  versionStore?: IVersionStore
  getRef?: (ref: IUpdateModalRef) => void
  onUpdate: (updateList: IServiceItem[]) => void
}

type TDialogType = 'service-update'
interface IEmit {
  (e: 'dialog-close', type: TDialogType): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    from: null,
    center: { type: Boolean, default: true },
    closeable: { type: Boolean, default: false },
    backdrop: { type: Boolean, default: false },
    versionStore: { default: undefined },
    getRef: { type: Function, default: undefined },
    onUpdate: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close', type: TDialogType): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { from: 'Home' | 'ServicePage', center: boolean, closeable: boolean, backdrop: boolean, versionStore: IVersionStore, getRef: (ref: IUpdateModalRef) => void, onUpdate: (updateList: IServiceItem[]) => void }

const isPC = isLargeViewPort()



const { close } = usePromisifyDialog<TDialogType>(emit)

const isMountedRef = ref(false)
const isUpdating = ref(false)
const progress = ref(0)
const pTimer = ref(0)
const updateList = computed<IServiceItem[]>(() => {
  const versionStore = props.versionStore || {}
  // 需要更新的服务
  const scheduling: IServiceItem[] = []
  Object.keys(versionStore).forEach(appid => {
    const service = versionStore[appid]
    const last_version = service.target || 0
    const curr_version = service.current || 0
    if (last_version <= curr_version) return
    scheduling.push(service)
  })
  return scheduling
})

const modalRef = reactive({
  close: () => {
    onClose()
  },
  setProgress: (p: number) => {
    if (p < 0) return
    progress.value = p >= 100 ? 100 : p
  },
})

function startUpdate () {
  const interval = 2500
  const list = unref(updateList)
  pTimer.value = window.setInterval(() => {
    const base = 10 ** 0
    const increased = Math.floor((10 / list.length) * base) / base
    progress.value += increased
    if (progress.value >= 100) {
      progress.value = 99
      window.clearInterval(pTimer.value)
      pTimer.value = 0
    }
  }, interval)
}

function onClose () {
  isMountedRef.value = false
  setTimeout(() => {
    close('service-update')
  }, 0)
}

function onConfirm () {
  if (checkState(true, true, false, false)) {
    onClose()
    return
  }
  props.onUpdate(unref(updateList))
  if (props.backdrop) {
    onClose()
  } else {
    isUpdating.value = true
    startUpdate()
  }
}

onMounted(() => {
  if (props.getRef) {
    props.getRef(modalRef)
  }
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})

onUnmounted(() => {
  console.log('[updateModal][unmounted]')
  if (pTimer.value) {
    window.clearInterval(pTimer.value)
    pTimer.value = 0
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-page", [
        {
          'shown': isMountedRef.value,
          'center': props.center,
        },
        _unref(isPC) ? 'pc-modal' : 'mobile-modal'
      ]])
    }, [
      (_unref(isPC))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!isUpdating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, [
                      _createVNode(SVGIcon, { name: "arrow-up-circle" })
                    ]),
                    _hoisted_4
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("ul", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(updateList), (service) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: service.appid,
                          class: "hstack list-item"
                        }, [
                          _hoisted_7,
                          _createElementVNode("p", _hoisted_8, _toDisplayString(service.name), 1),
                          _createElementVNode("span", _hoisted_9, "V " + _toDisplayString(service.target), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("button", {
                        class: "operation impt",
                        onClick: onConfirm
                      }, " 立即升级 "),
                      (__props.closeable)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "operation light",
                            onClick: onClose
                          }, " 暂不更新 "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (__props.closeable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-close",
                        onClick: onClose
                      }, _hoisted_13))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(SVGIcon, { name: "arrow-up-circle" })
                    ]),
                    _hoisted_17
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", {
                        class: "progress-stroke",
                        style: _normalizeStyle({ width: `${progress.value}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("p", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, _toDisplayString(progress.value) + "%", 1)
                    ])
                  ]),
                  (__props.closeable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-close",
                        onClick: onClose
                      }, _hoisted_25))
                    : _createCommentVNode("", true)
                ]))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!isUpdating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("ul", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(updateList), (service) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: service.appid,
                            class: "hstack list-item"
                          }, [
                            _hoisted_31,
                            _createElementVNode("p", _hoisted_32, _toDisplayString(service.name), 1),
                            _createElementVNode("span", _hoisted_33, "V " + _toDisplayString(service.target), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      (props.closeable)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: "cancel",
                            class: "btn cancel-btn",
                            onClick: onClose
                          }, _hoisted_36))
                        : _createCommentVNode("", true),
                      _createVNode(GradientButton, {
                        key: "confirm",
                        class: "btn confirm-btn",
                        onClick: onConfirm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", {
                        class: "progress-stroke",
                        style: _normalizeStyle({ width: `${progress.value}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("p", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("span", _hoisted_45, _toDisplayString(progress.value) + "%", 1)
                    ])
                  ])
                ]))
          ], 64))
    ], 2)
  ]))
}
}

})